module.exports = __webpack_public_path__ + "img/progress_date_graph.a7217001.svg";